<script>
import { required, email } from "vuelidate/lib/validators";

import {
  authMethods,
  authFackMethods,
  notificationMethods
} from "@/state/helpers";

//import axios from 'axios';
import api from '@/helpers/api-rest/api.js';

export default {
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      loading: false,
      loginError: null
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    }
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.loginError = null;
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;
        const apiEndpoint = `/api/login`;
        api.post({url:apiEndpoint, data:{
          email: this.email,
          password: this.password
        }})
        .then(response => {
          this.loading = false;
          const token = response.data.token;
          const user = response.data.user;
          localStorage.setItem('authToken', token);
          localStorage.setItem('user', JSON.stringify(user));

          if(user?.roles[0]?.slug === 'administrator'){
            this.$router.push({ name: 'home' });
          }else{
            this.$router.push({ name: 'map' });
          }
          
        })
        .catch(error => {
          this.loading = false;
          if (error.response && error.response.status === 401) {
            this.loginError = "Usuario o contraseña incorrectos";
          } else {
            console.error(error);
            this.loginError = "Error al intentar iniciar sesión. Por favor, inténtalo de nuevo más tarde.";
          }
          // this.loading = false;
          // console.error(error);
        });
      }
    }
  }
};
</script>

<template>
  <div>
    <!-- <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div> -->
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-8">
            <div role="tablist" style="z-index: 1;
    position: absolute;
    margin-top: 30vh;
    max-width: 85%;
    margin-left: 7%;">
              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                      v-b-toggle.accordion-1
                      class="text-dark"
                      href="javascript: void(0);"
                    >Productores</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed feugiat, eros vitae dignissim tempus, mauris orci vehicula tellus, et consequat risus nunc eget massa. Cras scelerisque rutrum tellus porttitor ullamcorper.</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                      v-b-toggle.accordion-2
                      class="text-dark"
                      href="javascript: void(0);"
                    >Consumidores</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed feugiat, eros vitae dignissim tempus, mauris orci vehicula tellus, et consequat risus nunc eget massa. Cras scelerisque rutrum tellus porttitor ullamcorper.</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="authentication-bg">
              <div class="bg-overlay">
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <!-- <div>
                          <a href="/" class="logo">
                            <img src="@/assets/images/logo-dark.png" height="20" alt="logo" />
                          </a>
                        </div> -->

                        <h4 class="font-size-18 mt-4">Welcome H2!</h4>
                        <p class="text-muted">Sign in to continue to H2.</p>
                      </div>

                      <b-alert
                        variant="danger"
                        class="mt-3"
                        v-if="notification.message"
                        show
                        dismissible
                      >{{notification.message}}</b-alert>

                      <div class="p-2 mt-5">
                        <form class="form-horizontal" @submit.prevent="tryToLogIn">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="email">Email</label>
                            <input
                              type="email"
                              v-model="email"
                              class="form-control"
                              id="email"
                              placeholder="Enter email"
                              :class="{ 'is-invalid': submitted && $v.email.$error }"
                            />
                            <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                              <span v-if="!$v.email.required">Email is required.</span>
                              <span v-if="!$v.email.email">Please enter valid email.</span>
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-lock-2-line auti-custom-input-icon"></i>
                            <label for="userpassword">Password</label>
                            <input
                              v-model="password"
                              type="password"
                              class="form-control"
                              id="userpassword"
                              placeholder="Enter password"
                              :class="{ 'is-invalid': submitted && $v.password.$error }"
                            />
                            <div
                              v-if="submitted && !$v.password.required"
                              class="invalid-feedback"
                            >Password is required.</div>
                          </div>
                          <div
                            v-if="loginError"
                            class="error-login"
                            v-bind:class="{ active: loginError }"
                          >{{ loginError }}</div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="customControlInline"
                            />
                            <label
                              class="custom-control-label"
                              for="customControlInline"
                            >Remember me</label>
                          </div>

                          <div class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                              :disabled="loading"
                            ><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                            Log In</button>
                          </div>

                          <div class="mt-4 text-center">
                            <router-link tag="a" to="/forgot-password" class="text-muted">
                              <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                            </router-link>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">
                        <p>
                          Don't have an account ?
                          <router-link
                            tag="a"
                            to="/register"
                            class="font-weight-medium text-primary"
                          >Register</router-link>
                        </p>
                        <!-- <p>
                          © 2020 Nazox. Crafted with
                          <i class="mdi mdi-heart text-danger"></i> by Themesdesign
                        </p> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .error-login {
    margin-bottom: 5%;
    background-color: red;
    color: white;
    padding: 10px;
    border-radius: 5px;
    display: none; /* Inicialmente ocultar el mensaje de error */
  }

  .error-login.active {
    display: block; /* Mostrar el mensaje de error cuando la clase 'active' está presente */
  }
</style>